import {configureStore} from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducer from './modules';
import sagas from './sagas';

const persistConfig = {
  key: 'root',
  storage,
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

let storeInstance = null;

export default function configureRootStore(initialState = {}) {
  const sagaMiddleware = createSagaMiddleware();

  const middlewares = [sagaMiddleware];
  const reduxStore = configureStore({
    reducer: persistedReducer,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({serializableCheck: false}).concat(middlewares),
  });

  let persistor = persistStore(reduxStore);

  sagaMiddleware.run(sagas);
  
  // Store the instance so it can be accessed from utility functions
  storeInstance = reduxStore;
  
  return { reduxStore, persistor };
}

// Export store instance getter for utility functions
export const getStore = () => storeInstance;
